import { store as reduxStore } from 'reactApp/store';
import { getPublicUrl } from 'reactApp/utils/urlHelper';

import { getCurrentFolder } from './helpers/getCurrentFolder';

// tempexp_17340-start

export const getChangeDesignUrl = () => {
    const state = reduxStore.getState();
    const folder = getCurrentFolder(state);
    const url = new URL(getPublicUrl(folder));
    url.searchParams.append('themeChooser', 'true');
    return url;
};

// tempexp_17340-end
